/**
 * King Living NumberInput Theme
 *
 * Global number input styling system for quantity picker:
 * - Enabled state: white background, gray border, brown plus button
 * - Disabled state: light gray background, muted colors
 * - Rounded container with minus, input, and plus buttons
 *
 * @override Extends Chakra UI NumberInput theme
 */

const NumberInput = {
  parts: ['root', 'field', 'stepperGroup', 'stepper'],
  baseStyle: {
    root: {
      // Container styling
      borderRadius: 'base', // 4px
      border: '1px solid',
      borderColor: 'brandColors.greyscale10', // Light gray border
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      gap: 0,
    },
    field: {
      // Input field styling
      border: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      backgroundColor: 'transparent',
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: 'sm',
      color: 'brandColors.greyscale',
      px: 2,
      py: 2,
      _focus: {
        boxShadow: 'none',
        outline: 'none',
      },
      _disabled: {
        backgroundColor: 'transparent',
        color: 'brandColors.greyscale40', // Desaturated gray
        cursor: 'not-allowed',
        opacity: 1,
      },
    },
    stepperGroup: {
      // Container for buttons
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
    },
    stepper: {
      // Button styling
      'border': 'none',
      'backgroundColor': 'transparent',
      'color': 'brandColors.greyscale50', // Medium-dark gray for minus
      'fontSize': 'lg',
      'fontWeight': 'normal',
      'px': 3,
      'py': 2,
      '_hover': {
        backgroundColor: 'transparent',
      },
      '_active': {
        backgroundColor: 'transparent',
      },
      '_focus': {
        boxShadow: 'none',
        outline: 'none',
      },
      '_disabled': {
        backgroundColor: 'transparent',
        color: 'brandColors.greyscale40', // Desaturated gray
        cursor: 'not-allowed',
        opacity: 1,
      },
      // Plus button (increment) styling
      '&:last-of-type': {
        color: 'brandColors.primaryDarkLinen', // Brownish-orange for plus
      },
      // Disabled plus button
      '&:last-of-type:disabled': {
        color: 'brandColors.greyscale40', // Desaturated gray when disabled
      },
    },
  },
  variants: {
    // Disabled state variant
    disabled: {
      root: {
        backgroundColor: 'brandColors.disabledBG', // Light gray background
        borderColor: 'brandColors.greyscale30', // Darker gray border
      },
      field: {
        color: 'brandColors.greyscale40', // Desaturated gray
      },
      stepper: {
        'color': 'brandColors.greyscale40', // Desaturated gray for all buttons
        '&:last-of-type': {
          color: 'brandColors.greyscale40', // Desaturated gray for plus when disabled
        },
      },
    },
  },
};

export default NumberInput;
